export enum ReportDetailsUserActionTypes {
    openReportDetailsPage = '[Report/User] Open Report Details Page',
    openKpiSetDetailsPage = '[Report/User] Open KPI Set Details Page',
    activateRecurringReport = '[Report/User] Activate Recurring Report',
    publishOneOffReport = '[Report/User] Publish OneOff Report',
    editNameAndDescription = '[Report/User] Edit name and description',
    editShareSettings = '[Report/User] Edit share settings',
    loadUsersFromEditShareSettings = '[Report/User] Load users from edit share settings',
    editReportDefinition = '[Report/User] Edit report definition',
    deleteReport = '[Report/User] Delete Report',
    printReport = '[Report/User] Print Report',
}

export enum ReportDetailsApiActionTypes {
    activateReportFailure = '[Report/Api] Activate Report Failure',
    activateReportSuccess = '[Report/Api] Activate Report Success',
    getReportSuccess = '[Report/Api] Get Report Success',
    getReportFailure = '[Report/Api] Get Report Failure',
    getReportEditionListSuccess = '[Report/Api] Get Report Edition List Success',
    getReportEditionListFailure = '[Report/Api] Get Report Edition List Failure',
    getLatestReportTemplateSuccess = '[Report/Api] Get Latest Report Template Success',
    getLatestReportTemplateFailure = '[Report/Api] Get Latest Report Template Failure',
    deleteReportSuccess = '[Report/Api] Delete Report Success',
    deleteReportFailure = '[Report/Api] Delete Report Failure',
    updateReportSuccess = '[Report/Api] Update Report Success',
    updateReportFailure = '[Report/Api] Update Report Failure',
}
